import React, { useContext, useEffect, useState } from 'react';
import fetchCustom from '../../wp_helpers/fetchCustom';

const JobEditContext = React.createContext(null);

const JobEditContextProvider = ({ children, config = {} }) => {
    const [steps, setSteps] = useState([]);

    const init = async () => {
        const flowRequest = await fetchCustom(config.get_job_recruitment_flow_steps);
        const flowResponse = await flowRequest.json();
        setSteps(flowResponse.steps);
    };

    useEffect(() => {
        init();
        window.addEventListener('change_recruitment_flow', () => init());
    }, []);

    return <JobEditContext.Provider value={{ config, steps }}>{children}</JobEditContext.Provider>;
};

export const useJobEdit = () => {
    const context = useContext(JobEditContext);
    if (!context) {
        throw new Error('useJobEdit must be used within a JobEditContextProvider');
    }
    return context;
};

export default JobEditContextProvider;
